import React from 'react';
import { useMsal } from '@azure/msal-react';
import Button from '../button';
import config from 'utils/config';
import { isWebView } from 'utils/commonFunctions';

function Login() {
  const { instance } = useMsal();

  const setLocalStorage = (token) => {
    if (token) {
      localStorage.setItem('accessToken', token);
    }
  };

  const handleRedirect = async () => {
    let loginRequest = {
      scopes: [
        'openid',
        'offline_access',
        config.envMsalAzureFlag
          ? 'https://accounts.icc-cricket.com/api/catalogue.read'
          : 'https://iccdevlogin.onmicrosoft.com/api/catalogue.read'
      ]
    };

    try {
      await instance.loginRedirect(loginRequest);
    } catch (error) {
      console.error('Login Redirect Error:', error);
    }
  };
  return (
    <>
      <Button
        variant={'primaryLink'}
        classes={'si-btn__login si-btn__login--link'}
        onClick={handleRedirect}
      >
        Log In
      </Button>
    </>
  );
}

export default Login;
